import { render, staticRenderFns } from "./ReportManager.vue?vue&type=template&id=20b0bad7"
import script from "./ReportManager.vue?vue&type=script&lang=ts"
export * from "./ReportManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports